import React from 'react';
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

const initialState = {
    socketId: '',
    _id: '',
    employeeList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        candidateType: 'active',
    },
    employeeModal: {
        flag: false,
        data: {}
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'FILTER_EMPLOYEE_LIST': {
            return {...state, employeeList: {...state.employeeList, currentPage: PAGINATION?.CURRENT_PAGE, ...action.payload}}
        }
        case 'SET_EMPLOYEE_MODAL': {
            return {...state, employeeModal: action.payload};
        }

        default: {
            return state;
        }
    }
}
